module.exports = __webpack_public_path__ + "59a6635183a53c24f36c74a35fbf2852.svg";